export const links = {
  linkedin: "https://www.linkedin.com/in/yusuf-brigui-814792208/",
  github: "https://github.com/ybrigui24",
  email: "mailto:briguiyoussef2005@icloud.com",
};

export const experience = [
  {
    role: "Backend & Data Engineering Intern",
    org: "Pixelium",
    location: "Tunisia - Hybrid",
    period: "Jul 2026 — Aug 2026",
    href: "https://pixelium.tech",
    points: [
      "Designed and deployed scalable web crawlers using Puppeteer and native HTTP requests to automate data harvesting across complex global procurement portals.",
      "Engineered a lightweight, asynchronous REST API gateway using Fastify to handle streaming high-volume data payloads directly into local databases over network sockets.",
      "Modeled unstructured data structures using Mongoose schemas; implemented custom cryptographic deduplication engines (SHA-256 content hashing hooks) to eliminate relational database duplication cleanly before persistence.",
      "Integrated an automated natural language layer to parse unstructured tender descriptions, programmatically tagging and categorizing listings into accurate business domains upon ingestion.",
    ]
  },
  {
    role: "Business & Operations Analyst Intern",
    org: "La Couronne Motors",
    location: "Sousse, Tunisia - Onsite",
    period: "Jun 2023 — Aug 2023",
    points: [
      "Analyzed core factory operations and authored a comprehensive report covering workflows, financial trends, and marketing strategies.",
      "Leveraged multilingual communication skills to effectively liaise with prospective suppliers and negotiate technical requirements.",
    ],
  },
  {
    role: "Executive Club Member",
    org: "International Student Community",
    location: "Istanbul, Turkey - Onsite",
    period: "Oct 2024 — Present",
    points: [
      "Co-organized on-campus and off-campus cultural and social events, contributing to the highest turnout in ISC history.",
      "Collaborated closely with team members to plan, coordinate, and execute engaging student experiences.",
      "Handled logistics, scheduling, and last-minute changes with strong problem-solving and organizational skills.",
      "Facilitated communication across diverse teams and participants to ensure smooth event delivery.",
    ],
  },
];

export const skills = {
  languages: [
    "Python",
    "Java",
    "Swift",
    "C",
    "SQL",
    "JavaScript",
    "HTML",
    "CSS",
    "Assembly",
    "React",
  ],
  tools: [
    "Git",
    "GitHub",
    "Linux",
    "MongoDB",
    "Node.JS",
    "Fastify API",
    "Next.JS",
    "Xcode",
    "Swing",
    "Figma",
    "Canva",
    "Microsoft Library",
  ],
  spoken: [
    { name: "English", level: "Native Proficiency" },
    { name: "Arabic", level: "Native" },
    { name: "French", level: "C2" },
    { name: "Spanish", level: "B2" },
    { name: "Turkish", level: "B2" },
    { name: "Chinese", level: "HSK2" },
  ],
};

export const projects = [
  {
    title: "HanDu 汉读",
    tag: "Swift · SwiftUI · Supabase · PostgreSQL",
    period: "Aug 2026",
    // Internal route, so the card must open in this tab rather than a new one.
    href: "/handu",
    internal: true,
    description: "iOS app for reading graded Chinese, with tap-to-translate built into the page.",
    points: [
      "Built a reader where tapping any word surfaces its pinyin and gloss, or the whole sentence in English, with both modes settable per text or as a global default.",
      "Modeled the corpus as texts → sentences → tokens in PostgreSQL, with Row Level Security scoping every read and per-user progress written server-side so it syncs across devices.",
      "Implemented email/password and Sign in with Apple auth, a deep-linked password-reset flow, and self-service account deletion through an Edge Function that cascades away all user data.",
    ],
  },
  {
    title: "crawler",
    tag: "JavaScript · Node.Js · MongoDB · Fastify · React ",
    period: "Jul 2026",
    href: "https://github.com/ybrigui24/crawler",
    description:
      "AI-Driven Full-Stack Data Pipeline & Public Procurement Analytics Suite",
    points: [
      "Headless Automation Layer navigates dynamic, client-side JavaScript tables, pagination sequences, and session configurations using target-specific Puppeteer scripts.",
      "Automated AI Processing extracts raw text blocks and routes them through a language processing sequence to tag records by industry, category, and urgency automatically.",
      "SSR Web Dashboard built with Next.js and React, featuring server-side rendering for lightning-fast keyword search, dynamic filtering, and a seamless data visualization interface.",
    ],
  },{
    title: "Knowledge Siege",
    tag: "Java · Swing · OOP",
    period: "May 2025",
    href: "https://github.com/ybrigui24/KnowledgeSiege",
    description:
      "Cross-platform computer game built on a clean, extensible engine.",
    points: [
      "Employed OOP principles — inheritance, polymorphism, and interfaces — to model game entities and behaviors.",
      "Implemented file-based persistence using Java I/O streams and Formatter for user authentication and session tracking.",
      "Designed an event-driven Swing GUI with custom rendering, input handling, and dynamic scoreboards.",
    ],
  },
  {
    title: "Sustainability Analysis of (RED)'s Marketing Strategy",
    tag: "Research & Analysis",
    period: "May 2024",
    description:
      "Research and analytical report on a collaborative marketing strategy.",
    points: [
      "Conducted a structured analysis of (RED)'s marketing strategy using data-driven frameworks including ROI modeling, SWOT, and STEEPLE.",
    ],
  },
];

export const education = [
  {
    school: "Koç University",
    degree: "BEng in Computer Engineering",
    period: "Oct 2024 — Jun 2028",
    detail:
      "Computer Engineering student at Koç University with a strong focus on systems design, software development, and low-level performance optimization. Engaged in hands-on projects and coursework that emphasize practical applications of computer engineering principles.",
  },
  {
    school: "Gokkusagi College",
    degree: "International Baccalaureate Diploma Program",
    period: "Sept 2022 — Jun 2024",
    detail: "IB Diploma Awarded.",
  },
];
